import { render, staticRenderFns } from "./header-countdown-config-edit.vue?vue&type=template&id=298089fd&scoped=true&"
import script from "./header-countdown-config-edit.vue?vue&type=script&lang=ts&"
export * from "./header-countdown-config-edit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298089fd",
  null
  
)

export default component.exports